import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { observer } from 'mobx-react';

import ExerciseContext from '../../../../context/ExerciseContext';
import OverrideActions from '../../../OverrideActions';
import {
  Row,
  Body,
  ExerciseBlock,
  Chip,
  ExerciseName,
  Chevron,
  MetaItem,
  ReasonQuote,
  ActionSlot,
} from './styles';
import texts from './texts.json';

const ReplacementRow = ({ userId, originalExerciseId, entry }) => {
  const { exercises } = useContext(ExerciseContext);
  let originalExercise;
  let replacementExercise;
  exercises.forEach((e) => {
    if (e.id === originalExerciseId) {
      originalExercise = e;
    }
    if (e.id === entry.overrideExerciseId) {
      replacementExercise = e;
    }
  });
  const originalName = originalExercise?.name || texts.unknownExercise;
  const replacementName = replacementExercise?.name || texts.unknownExercise;

  const date = entry.date?.toDate?.();
  const formattedDate = date ? moment(date).format('MMM D, YYYY') : '';

  return (
    <Row>
      <Body>
        <ExerciseBlock>
          <Chip>{texts.originalLabel}</Chip>
          <ExerciseName>{originalName}</ExerciseName>
          {entry.matchedRestriction && (
            <ReasonQuote>
              {`${texts.reasonPrefix} "${entry.matchedRestriction}"`}
            </ReasonQuote>
          )}
        </ExerciseBlock>

        <Chevron fontSize="small" />

        <ExerciseBlock>
          <Chip>{texts.replacementLabel}</Chip>
          <ExerciseName>{replacementName}</ExerciseName>
        </ExerciseBlock>

        <ActionSlot>
          <OverrideActions
            userId={userId}
            originalExerciseId={originalExerciseId}
            originalName={originalName}
            currentReplacementName={replacementName}
          />
        </ActionSlot>
      </Body>

      {formattedDate && <MetaItem>{formattedDate}</MetaItem>}
    </Row>
  );
};

ReplacementRow.propTypes = {
  userId: PropTypes.string.isRequired,
  originalExerciseId: PropTypes.string.isRequired,
  entry: PropTypes.shape({
    id: PropTypes.string,
    overrideExerciseId: PropTypes.string.isRequired,
    date: PropTypes.object,
    matchedRestriction: PropTypes.string,
  }).isRequired,
};

export default observer(ReplacementRow);
